import {useRef } from "react";
import React from "react";

export const Leads = (props) => {

  const nome    = useRef(null);
  const empresa = useRef(null);
  const cargo   = useRef(null);
  const email   = useRef(null);
  const whatsapp = useRef(null);

  function handleClick() {

      const nome_     = nome.current.value;
      const empresa_  = empresa.current.value;
      const cargo_    = cargo.current.value;
      const email_    = email.current.value;
      const whatsapp_ = whatsapp.current.value;
      if(nome_ != null && empresa_ != null && cargo_ != null && email_ != null && whatsapp_ != null && whatsapp_.length  == 11) {
        window.open("https://api.whatsapp.com/send/?phone=5521975841912&text=Olá, meu nome é " + nome_ + ",sou " + cargo_ + " na empresa " + empresa_+ ", meu email é " + email_ + ", e eu gostaria de saber um pouco mais sobre os produtos Atise. *Enviado de: " +whatsapp_+ "*");
      }else{
        alert("VOCÊ PRECISA PREENCHER TODOS OS CAMPOS NECESSÁRIOS\n\n*CAMPO TELEFONE/WHATSAPP PRECISA ESTAR PREENCHIDO CORRETAMENTE!*")
      }
     
 
  }

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-6">
            <div className="row">
              <div id="contact-form">
              <div className="section-title">
                <h2>Transforme sua Experiência com Assistência Veicular 24h!</h2>
                <p>
                Descubra como nosso serviço especializado pode impulsionar suas vendas e a experiência do cliente. Estamos prontos para fornecer todos os indicadores para um crescimento saudável e escalável, com qualidade e baixo risco.

                </p>
              </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                       <input
                          ref={nome}
                          type="text"
                          id="nome"
                          name="nome"
                          className="form-control"
                          placeholder="Nome completo"
                          required
                        />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        ref={empresa}
                        type="text"
                        id="empresa"
                        name="empresa"
                        className="form-control"
                        placeholder="Empresa"
                        required
                        
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        ref={email}
                        type="text"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        ref={cargo}
                        type="text"
                        id="message"
                        name="message"
                        className="form-control"
                        placeholder="Cargo"
                        required
                        
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <input
                    ref={whatsapp}
                    type="tel"
                    pattern="[0-9.]+"
                    id="whatsapp"
                    name="whatsapp"
                    className="form-control"
                    placeholder="Whatsapp ex: (21)99999-9999"
                    required
                    
                  />
                  <p className="help-block text-danger"></p>
                </div>
                <p id="call"> Conheça nossos planos e transforme sua gestão de frota hoje mesmo!</p>
                <div id="success"></div>
                
                <button type="submit" onClick={handleClick} className="btn btn-custom btn-lg" id="btn">
                  QUERO CONHECER MAIS A ATISE
                </button>
                </div>
            </div>
          </div>
          <div className="col-md-5 col-md-offset-1 contact-info">
            <div className="contact-item">
            <img id="imgAtise"src="img/woman.png" className="img-responsive" alt="" />{" "}
            </div>
          </div>
     
        </div>
      </div>
  
    </div>
  );
};
